module.exports = __webpack_public_path__ + "img/Get paid.5d36cbd0.svg";